/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetFlatTourBookingScheduleModel,
  IGetFlatTourBookingScheduleRequest,
  IMappers,
  IGetFlatTourBookingScheduleResponse,
  IGetFlatTourBookingScheduleResponseError,
  TGetFlatTourBookingScheduleResponse,
} from './types';

const defaultConfig: TGetFlatTourBookingScheduleModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'newbuilding-calltracking',
  pathApi: '/v1/get-flat-tour-booking-schedule',
  hostType: 'api',
} as TGetFlatTourBookingScheduleModel;

function createGetFlatTourBookingScheduleModel(
  parameters: IGetFlatTourBookingScheduleRequest,
): TGetFlatTourBookingScheduleModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetFlatTourBookingScheduleOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetFlatTourBookingScheduleRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetFlatTourBookingSchedule<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetFlatTourBookingScheduleOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetFlatTourBookingScheduleResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetFlatTourBookingScheduleModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetFlatTourBookingScheduleResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetFlatTourBookingScheduleResponseError);
    }
  }

  return { response, statusCode } as TGetFlatTourBookingScheduleResponse;
}

export { defaultConfig, createGetFlatTourBookingScheduleModel, fetchGetFlatTourBookingSchedule };
